export const customerConstants = {
	GET_CUSTOMER_BY_AUTH_AND_STATUS_REQUEST: 'GET_CUSTOMER_BY_AUTH_AND_STATUS_REQUEST',
	GET_CUSTOMER_BY_AUTH_AND_STATUS_SUCCESS: 'GET_CUSTOMER_BY_AUTH_AND_STATUS_SUCCESS',
	GET_CUSTOMER_BY_AUTH_AND_STATUS_FAILURE: 'GET_CUSTOMER_BY_AUTH_AND_STATUS_FAILURE',

	GET_CUSTOMER_INFO_BY_AUTH_REQUEST: 'GET_CUSTOMER_INFO_BY_AUTH_REQUEST',
	GET_CUSTOMER_INFO_BY_AUTH_SUCCESS: 'GET_CUSTOMER_INFO_BY_AUTH_SUCCESS',
	GET_CUSTOMER_INFO_BY_AUTH_FAILURE: 'GET_CUSTOMER_INFO_BY_AUTH_FAILURE',

	NEW_BOOK_CUSTOMER_REQUEST: 'NEW_BOOK_CUSTOMER_REQUEST',
	NEW_BOOK_CUSTOMER_SUCCESS: 'NEW_BOOK_CUSTOMER_SUCCESS',
	NEW_BOOK_CUSTOMER_FAILURE: 'NEW_BOOK_CUSTOMER_FAILURE',

	DELETE_BOOK_CUSTOMER_REQUEST: 'DELETE_BOOK_CUSTOMER_REQUEST',
	DELETE_BOOK_CUSTOMER_SUCCESS: 'DELETE_BOOK_CUSTOMER_SUCCESS',
	DELETE_BOOK_CUSTOMER_FAILURE: 'DELETE_BOOK_CUSTOMER_FAILURE',
}
